import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './farmerdetails.css';

const FarmerDetails = () => {
  const { state } = useLocation();

  const [details, setDetails] = useState({
    farmid: '',
    name: '',
    area: '',
    phone: '',
    dob: '',
    aadhar: '',
    bankName: '',
    accountNumber: '',
    ifsc: '',
    village: ''
  });

  useEffect(() => {
    if (state) {
      setDetails(prev => ({
        ...prev,
        ...state
      }));
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!details.farmid || !details.name || !details.phone) {
      alert('Please fill required fields like Farm ID, Name, and Phone.');
      return;
    }

    try {
      const res = await fetch('https://kmtea.onrender.com/savefarmerdata', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(details),
      });

      if (res.ok) {
        alert('Farmer details saved successfully!');
        setDetails({
          farmid: '',
          name: '',
          area: '',
          phone: '',
          dob: '',
          aadhar: '',
          bankName: '',
          accountNumber: '',
          ifsc: '',
          village: ''
        });
      } else {
        alert('Failed to save farmer details.');
      }
    } catch (err) {
      console.error(err);
      alert('Error connecting to backend.');
    }
  };

  return (
    <div className='farmer-details'>
      <h2>{state?.mode === 'edit' ? 'Edit Farmer' : 'Farmer Registration'}</h2>

      <div className='farmer1'>
        <h3>Personal Info</h3>
        <div className='farm'>
          <div>
            <label>Farm ID</label>
            <input name="farmid" value={details.farmid} onChange={handleChange} placeholder="Farm ID" />
          </div>
          <div>
            <label>Name</label>
            <input name="name" value={details.name} onChange={handleChange} placeholder="Name" />
          </div>
        </div>

        <div className='dob'>
          <div>
            <label>DOB</label>
            <input type="date" name="dob" value={details.dob} onChange={handleChange} />
          </div>
          <div>
            <label>Aadhar No</label>
            <input name="aadhar" value={details.aadhar} onChange={handleChange} placeholder="Aadhar No" />
          </div>
        </div>

        <div>
          <label>Phone</label>
          <input name="phone" value={details.phone} onChange={handleChange} placeholder="Phone" />
        </div>
      </div>

      <div className='farmer2'>
        <h3>Address Information</h3>
        <div className='city'>
          <div>
            <label>City</label>
            <input name="area" value={details.area} onChange={handleChange} placeholder="City" />
          </div>
          <div>
            <label>Pincode</label>
            <input name="village" value={details.village} onChange={handleChange} placeholder="Pincode" />
          </div>
        </div>
      </div>

      <div className='farmer3'>
        <h3>Bank Info</h3>
        <div>
          <label>Bank Name</label>
          <input name="bankName" value={details.bankName} onChange={handleChange} placeholder="Bank Name" />
        </div>
        <div>
          <label>Account Number</label>
          <input name="accountNumber" value={details.accountNumber} onChange={handleChange} placeholder="Account Number" />
        </div>
        <div>
          <label>IFSC Code</label>
          <input name="ifsc" value={details.ifsc} onChange={handleChange} placeholder="IFSC Code" />
        </div>
      </div>

      <center>
        <button onClick={handleSave}>
          {state?.mode === 'edit' ? 'Update Farmer' : 'Register Farmer'}
        </button>
      </center>
    </div>
  );
};

export default FarmerDetails;
